module.exports = __webpack_public_path__ + "img/exclamation-mark-edited.61256e30.png";